var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 19.1071C11.5625 20.8271 12.8825 22.2138 14.5225 22.2138H17.8692C19.2958 22.2138 20.4558 21.0004 20.4558 19.5071C20.4558 17.8804 19.7492 17.3071 18.6958 16.9338L13.3225 15.0671C12.2692 14.6938 11.5625 14.1204 11.5625 12.4938C11.5625 11.0004 12.7225 9.78711 14.1492 9.78711H17.4958C19.1358 9.78711 20.4558 11.1738 20.4558 12.8938",
    stroke: "#0C0C0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8V24",
    stroke: "#0C0C0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0013 29.3327H12.0013C5.33464 29.3327 2.66797 26.666 2.66797 19.9993V11.9993C2.66797 5.33268 5.33464 2.66602 12.0013 2.66602H20.0013C26.668 2.66602 29.3346 5.33268 29.3346 11.9993V19.9993C29.3346 26.666 26.668 29.3327 20.0013 29.3327Z",
    stroke: "#0C0C0C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.4ca8759dfacf7a792fcb8a754ba83022.svg";
export { ForwardRef as ReactComponent };